import I18n from 'i18n'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import TranscriptView from './TranscriptView'

export default class SelectedTranscriptDisplay extends Component {
  static propTypes = {
    endTime: PropTypes.number.isRequired,
    searchHighlights: PropTypes.array,
    startTime: PropTypes.number.isRequired,
    videoTranscript: PropTypes.object.isRequired
  }

  getTranscript() {
    return (
      this.props.videoTranscript.transcript || I18n.t('No transcript provided')
    )
  }

  render() {
    const {
      startTime,
      endTime,
      videoTranscript: { jsonTimestamps },
      searchHighlights
    } = this.props
    return (
      <TranscriptView
        text={this.getTranscript()}
        timestamps={jsonTimestamps}
        tokens={searchHighlights}
        selectionStartTime={startTime}
        selectionEndTime={endTime}
      />
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/SelectedTranscriptDisplay.js